const styles = {
  root: {
    paddingBottom: 20,
    '& table': {
      width: '100%',
      borderCollapse: 'collapse',
      '& thead tr': {
        borderBottom: '1px solid #DADADA',
      },
      '& tbody tr:nth-child(even)': {
        background: '#E9EFFD',
        '& td:first-child': {
          borderRadius: '8px 0 0 8px',
        },
        '& td:last-child': {
          borderRadius: '0 8px 8px 0',
        },
      },
      '& td': {
        padding: 16,
      },
      '& tbody td:last-child': {
        textAlign: 'right',
      },
    },
  },
  type: {
    '& .type': {
      border: '1px solid #dadada',
      padding: '8px 16px',
      borderRadius: 25,
      '&.selected': {
        fontWeight: 'bold',
        border: '1px solid #E87A46',
        background: '#FDF2ED',
      },
    },
  },
};

export default styles;
